import { useTranslation } from 'react-i18next';
import BadgeCustom from '../../../../../../components/common/CustomBadge/CustomBadge';
import type { FileItem } from '../../../../../../types/File/File.types';
import { formatDate, formatFileSize } from '../../../../../../utils/utils';

interface FileInformationPanelProps {
    file: FileItem;
    isVisible: boolean;
}

export function FileInformationPanel({ file, isVisible }: FileInformationPanelProps) {
    const { t } = useTranslation();
    return (
        <div className={`${isVisible ? 'block' : 'hidden md:block'} w-full overflow-auto border rounded-md`}>
            <div className="p-4 border-b">
                <h3 className="font-medium">{t('fileInformation.title')}</h3>
            </div>
            <div className="p-4 space-y-4">
                {/* File Details Section */}
                <div>
                    <h4 className="text-sm font-medium mb-1">{t('fileInformation.details.title')}</h4>
                    <div className="text-sm space-y-1">
                        <p>
                            <span className="text-muted-foreground">{t('fileInformation.details.size')}:</span>{' '}
                            {file.size ? formatFileSize(file.size) : '—'}
                        </p>
                        <p>
                            <span className="text-muted-foreground">{t('fileInformation.details.modified')}:</span>{' '}
                            {formatDate(file.modifiedAt)}
                        </p>
                        <p>
                            <span className="text-muted-foreground">{t('fileInformation.details.modifiedBy')}:</span>{' '}
                            {file.modifiedBy || t('fileInformation.details.unknownUser')}
                        </p>
                        <p>
                            <span className="text-muted-foreground">{t('fileInformation.details.status')}:</span>{' '}
                            {file.status === 'analyzed'
                                ? t('fileInformation.details.statusAnalyzed')
                                : t('fileInformation.details.statusNotAnalyzed')}
                        </p>
                        <p>
                            <span className="text-muted-foreground">{t('fileInformation.details.active')}:</span>{' '}
                            {file.active
                                ? t('fileInformation.details.activeYes')
                                : t('fileInformation.details.activeNo')}
                        </p>
                    </div>
                </div>

                {/* Summary Section */}
                <div>
                    <h4 className="text-sm font-medium mb-1">{t('fileInformation.summary.title')}</h4>
                    <p className="text-sm">{file.summary || t('fileInformation.summary.notAvailable')}</p>
                </div>

                {/* Topics Section */}
                {file?.topics && file.topics.length > 0 && (
                    <div>
                        <h4 className="text-sm font-medium mb-1">{t('fileInformation.topics.title')}</h4>
                        <div className="flex flex-wrap gap-1">
                            {file.topics.map((topic, index) => (
                                <BadgeCustom key={index} variant="default">
                                    {topic}
                                </BadgeCustom>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
